/** Shared cancel-request button styles used by EventAttendeeCard. */
export const ATTENDEE_CANCEL_REQUEST_CSS = `
  .attendee-cancel-request-btn {
    background-color: #fff !important;
    border: 1px solid #dc3545 !important;
    color: #dc3545 !important;
  }
  .attendee-cancel-request-btn:hover:not(:disabled),
  .attendee-cancel-request-btn:focus-visible:not(:disabled) {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #fff !important;
  }
  .attendee-cancel-request-btn:disabled {
    opacity: 0.65;
  }
`;

export function AttendeeCancelRequestStyles() {
  return <style>{ATTENDEE_CANCEL_REQUEST_CSS}</style>;
}
